import { render, staticRenderFns } from "./PerfilApp.vue?vue&type=template&id=a12adf72&scoped=true"
import script from "./PerfilApp.vue?vue&type=script&lang=js"
export * from "./PerfilApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12adf72",
  null
  
)

export default component.exports